var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"call-wrapper"},[_c('a',{attrs:{"href":'https://api.whatsapp.com/send?phone=' + _vm.webset.whatsapp + '&msg=' + _vm.webset.sayhi}},[_c('img',{attrs:{"src":require("@/assets/images/what-app-icon.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }